module.exports = __webpack_public_path__ + "img/supplier_download_bg.fb9b2da1.png";